import $ from 'jquery';

function FloatingChat() {
    const d = new Date();
    let wk_day = d.getDay();
    let hr = d.getHours();

    // NOTE: when changing the hours below, be sure to also change the hours in cml-wordpress/template-parts/floating-chat.php
    const display =
        (wk_day >= 1 && wk_day <= 4 && hr >= 9 && hr < 21) ||
        ((wk_day == 5 || wk_day == 6) && hr >= 9 && hr < 18) ||
        (wk_day == 0 && hr >= 13 && hr < 17);

    if (display) {
        $('#chat-content-container .chat-online').show();
        $('#chat-content-container .chat-offline').hide();
    }

    $('#question-tab').click(function () {
        $('#chat-inner').toggle('slide');
    });
    $('#chat-close').click(function () {
        $('#chat-inner').toggle('slide');
    });

    $('#chat-skip-link').click(function (e) {
        $('#chat-inner').toggle('slide');
    });
}

export { FloatingChat };
